document.addEventListener("variant:add", function (event) {
  let itemsAdded = event.detail.items; // Get items added
  let cart = event.detail.cart; // The whole cart content after the update

  fetch(
    window.Shopify.routes.root +
      "products/" +
      itemsAdded[0].handle +
      "?view=add-scoop",
    {
      method: "GET",
    }
  )
    .then((response) => response.text())
    .then((response) => {
      let product_metafield = JSON.parse(response);
      //console.log("result", product_metafield);
      if (product_metafield.auto_add_scoop_pack) {
        let items = cart.items;
        let item_in_cart_already = false;
        let cart_contains_subscription_product = false;
        let item_to_add_prod_id = 6554834010164;
        let item_to_add_variant_id = 39319435182132;

        for (var i = 0; i < items.length; i++) {
          if (items[i].product_id == item_to_add_prod_id) {
            item_in_cart_already = true;
          }

          if (items[i].selling_plan_allocation != undefined) {
            cart_contains_subscription_product = true;
          }
        }

        if (!item_in_cart_already) {
          let formData = {
            items: [
              {
                id: item_to_add_variant_id,
                quantity: 1,
                properties: { "_auto-added": true },
              },
            ],
          };

          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          })
            .then((response) => {
              document.documentElement.dispatchEvent(
                new CustomEvent("cart:refresh", {
                  bubbles: true,
                })
              );
              return response.json();
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        }
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
});
